export const seoToolsTabsArticle = {
  title: 'SEO Tools Hub: Analyzer, Traffic & Keywords',
  slug: 'seo-tools-tabs',
  content: `SEO Tools Hub: Analyzer, Traffic & Keywords

Use the core SEO tools in the tab bar.

1) SEO Analyzer
- Run audits and review SEO health.

2) Web Traffic
- Review traffic analytics and trends.

3) Keyword Research
- Research keywords and track opportunities.

Tip
- Tabs are hash-based (#seo-analyzer, #web-traffic, #keyword-research).
`,
};
